define("shared/utils/retry", ["exports", "ember-concurrency", "rsvp", "later/errors/fetch"], function (_exports, _emberConcurrency, _rsvp, _fetch) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.STRATEGY = void 0;
  _exports.retry = _exports.default = retry;
  0; //eaimeta@70e063a35619d71f0,"@embroider/macros",0,"ember-concurrency",0,"rsvp",0,"later/errors/fetch"eaimeta@70e063a35619d71f
  /**
   * @class retry
   * @extends Utils
   */

  const STRATEGY = _exports.STRATEGY = {
    BACKOFF: (initialWait, retryCount) => {
      const quadrupleWait = initialWait * 4;
      return 2 ** retryCount * quadrupleWait;
    },
    CONSTANT: initialWait => initialWait,
    DEFAULT: (initialWait, retryCount) => STRATEGY.LINEAR(initialWait, retryCount),
    LINEAR: (initialWait, retryCount) => retryCount * initialWait,
    TESTING: () => 0
  };
  function retry(callback) {
    let maxRetries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    let strategy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : STRATEGY.DEFAULT;
    let retryCount = 0;
    let lastError = null;
    if (maxRetries === 0) {
      return callback();
    }
    const retryCallback = callback => {
      if (retryCount >= maxRetries) {
        return _rsvp.default.reject(lastError);
      }
      return callback(retryCount, maxRetries).catch(async error => {
        let instanceStrategy = false ? STRATEGY.TESTING : strategy;
        lastError = error;
        if (error instanceof _fetch.RequestError) {
          retryCount = maxRetries;
        } else if (error instanceof _fetch.RateLimitError) {
          instanceStrategy = STRATEGY.BACKOFF;
        }
        retryCount++;
        const initialWait = 1000;
        const delay = instanceStrategy(initialWait, retryCount);
        await (0, _emberConcurrency.timeout)(delay);
        return retryCallback(callback);
      });
    };
    return retryCallback(callback);
  }
});